module.exports = __webpack_public_path__ + "static/media/vf_wtop_core.5fccdb32.svg";